export default __webpack_public_path__ + "static/media/LF-3.b42f5a8a.png";